// extracted by mini-css-extract-plugin
export var chatHtmlText = "_os-2";
export var chatLink = "_os-0";
export var chatText = "_os-1";